<template>
  <div class="global-advanced-portal-student" :class="{ dark }">
    <v-container
      class="config-form-content adminWeeducPortalStudentImage weeduc-admin-config"
      data-aos="fade-left"
      data-aos-duration="1500"
      fluid
    >
      <!-- Título -->
      <v-row id="titleContainerPortalStudent">
        <v-col cols="12">
          <div class="titleContainer myCoursesWeeduc">
            <div class="title-wrapper">
              <h5>Portal do Aluno</h5>
              <p style="font-size: 14px; margin-bottom: 0">
                Configurações do Portal do Aluno e configurações avançadas de interação com o aluno
              </p>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Formulários -->
      <v-row id="contentContainerPortalStudent">
        <!-- Coluna 1 -->
        <v-col cols="12" md="6" id="contentSelectContainerPortalStudent">
          <v-card class="pa-4" outlined>
            <label for="portalStudentImageSelect" class="labeld required">Configurações do Portal do Aluno</label>

            <v-select
              v-model="showCertificate"
              :items="optionsAtivoInativo"
              item-title="text"
              item-value="value"
              label="Exibir Certificado"
              variant="outlined"
              density="compact"
              class="mb-4"
              hide-details="auto"
            />
            <small>Após a conclusão do curso, o aluno poderá baixar o certificado de conclusão.</small>
            <br><br>

            <v-select
              v-model="showInquiry"
              :items="optionsAtivoInativo"
              item-title="text"
              item-value="value"
              label="Exibir Dúvidas"
              variant="outlined"
              density="compact"
              class="mb-4"
              hide-details="auto"
            />
            <small>O aluno poderá responder dúvidas para melhorar o curso.</small>
            <br><br>

            <v-select
              v-model="showForum"
              :items="optionsAtivoInativo"
              item-title="text"
              item-value="value"
              label="Exibir Fórum"
              variant="outlined"
              density="compact"
              class="mb-4"
              hide-details="auto"
            />
            <small>O aluno poderá interagir com o fórum para compartilhar dúvidas e conhecimento.</small>
          </v-card>
        </v-col>

        <!-- Coluna 2 -->
        <v-col cols="12" md="6" id="contentImageContainerPortalStudent">
          <label for="portalStudentImageSelect" class="labeld required">Imagem do Portal do Aluno</label>
          <CustomFileInput
            id="portalStudentImageSelect"
            v-model="image"
            :image-preview="imagePreview"
            height="160"
            :can-delete="false"
            infoText="Selecione uma imagem no formato JPG ou PNG"
            @update:modelValue="updateFilePath"
          />
          <p class="helper-text mt-1">Tamanho recomendado: 1280x500 pixels (proporção 16:5)</p>
        </v-col>
      </v-row>

      <!-- Botão -->
      <v-row id="buttonContainerPortalStudent">
        <v-col cols="12" class="d-flex justify-end">
          <v-btn
            color="primary"
            class="btn-content"
            @click="salvarPortalAluno"
            :loading="loading"
            :disabled="loading"
            id="btnSavePortalStudent"
          >
            <span v-if="!loading">Salvar e Publicar</span>
            <span v-else>Carregando...</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import apiAWS from '@/utils/storage/aws'
import apiWebsite from '@/utils/Weflix/content'
import { mapState } from 'vuex'
import CustomFileInput from '@/components/Form/CustomFileInput.vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'PortalStudentImageUpload',
  components: {
    CustomFileInput,
  },
  data() {
    return {
      image: '',
      imagePreview: null,
      imageUpload: null,
      loading: false,
      dataWebsite: null,
      showCertificate: 1,
      showInquiry: 1,
      showForum: 1,
      optionsAtivoInativo: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 },
      ],
    }
  },
  computed: {
    ...mapState(['token', 'dark']),
  },
  methods: {
    async getDataWebsite() {
      try {
        const response = await apiWebsite.getWebsite(this.token)
        console.log(response)
        this.dataWebsite = response
        if (response) {
          this.showCertificate = response.showCertificate ?? 1
          this.showInquiry = response.showInquiry ?? 1
          this.showForum = response.showForum ?? 1
          this.image = typeof response.portalBannerFinalPath === 'string' ? response.portalBannerFinalPath : ''
          this.imagePreview = this.image ? this.image : null
        }
      } catch (error) {
        toast.error('Erro ao buscar dados do site')
        console.error('Erro ao buscar dados do site:', error)
      }
    },
    updateFilePath(novoValor) {
      // Se for um arquivo, faz upload para AWS, senão apenas define o path
      if (novoValor && typeof novoValor === 'object' && novoValor instanceof File) {
        // Remove o preview anterior se existir
        if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
          URL.revokeObjectURL(this.imagePreview)
        }
        this.imagePreview = URL.createObjectURL(novoValor)
        this.uploadImageAws(novoValor)
      } else {
        // Se for string (url), seta o preview para a url
        this.image = novoValor || ''
        this.imagePreview = this.image ? this.image : null
      }
    },
    async uploadImageAws(file) {
      try {
        const assinatura = await apiAWS.getSignatureImage(this.token, file.name)
        await this.putFileAws(assinatura.url, file)
        this.imageUpload = assinatura.token
        // Após upload, o preview já está setado pelo objeto local
      } catch (error) {
        this.notify('Erro ao enviar imagem para o servidor.', 'error')
      }
    },
    async putFileAws(url, file) {
      try {
        await apiAWS.putFileAWS(url, file)
      } catch (error) {
        this.notify('Erro ao salvar a imagem.', 'error')
      }
    },
    notify(mensagem, tipo = 'info') {
      // Aqui você pode integrar com um sistema de toast global, se desejar
      // Exemplo: this.$toast(mensagem, { type: tipo })
      // Por enquanto, apenas loga no console
      console.log(`[${tipo}] ${mensagem}`)
    },
    async salvarPortalAluno() {
      this.loading = true
      try {
        // Garante que portalBannerPath será string ou vazio, nunca objeto
        const payload = {
          ...this.dataWebsite,
          portalBannerPath: this.imageUpload,
          showCertificate: this.showCertificate,
          showInquiry: this.showInquiry,
          showForum: this.showForum,
        }
        const response = await apiWebsite.updateWebsite(
          this.token,
          this.dataWebsite.id,
          payload
        )
        this.notify('Configurações salvas com sucesso!', 'success')
        console.debug(response)
      } catch (error) {
        this.notify('Erro ao atualizar o portal do aluno.', 'error')
        console.error('Erro ao atualizar o portalBannerPath:', error)
      } finally {
        this.loading = false
      }
    },
  },
  beforeUnmount() {
    if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.imagePreview)
    }
  },
  mounted() {
    this.getDataWebsite()
  },
}
</script>

<style scoped>
@import url('./css/portalStudent.css');
</style>
